<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
        <v-card
            class="mt-7"
            width="500"
        >  
           
            <v-toolbar 
                color="primary"
                dark
            >
                <v-toolbar-title>Term Reports</v-toolbar-title>  
            </v-toolbar>
            <v-list two-line>
                <v-list-item-group
                    v-model="selected"
                    active-class="primary--text"                    
                >
                    <div v-for="(item, index) in items" :key="index">
                        <v-list-item @click="displayReport(item)">
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>

                                    <v-list-item-subtitle
                                        class="text--primary"
                                        v-text="item.headline"
                                    ></v-list-item-subtitle>                                  

                                   
                                    <v-list-item-subtitle
                                        v-text="item.subtitle"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                                    <v-icon
                                        v-if="!active"
                                        color="grey lighten-1"
                                    >
                                        mdi-star-outline
                                    </v-icon>

                                    <v-icon
                                        v-else
                                        color="yellow darken-3"
                                    >
                                        mdi-star
                                    </v-icon>

                                </v-list-item-action>

                                

                            </template>
                        </v-list-item>

                        <v-divider
                            v-if="index < items.length - 1"
                            :key="index"
                        ></v-divider>

                    </div>
                </v-list-item-group>
            </v-list>
            
        </v-card>
        </v-row>
        
       <PDFViewer 
            :url="url" 
            :initialDialog="reportCard"
            :reportName="reportName"
            @closeDialog="reportCard = false"  
        />           
    </layout>    
</template>

<script>
import Layout from './layouts/App';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PDFViewer from './PDFViewer';

export default {
    name: 'TermReport',
    components: {
        Layout,
        PDFViewer,
    },

    created(){
        this.initialize();
    },
    
    data: () => ({
        reportCard: false,
        selected: -1,
        items: [],
        url: null,
        reportName: null,
    }),

    computed:{
        ...mapGetters({
            user: 'auth/getUser',
            studentId: 'auth/getStudentId',
            reportTerms: 'report/getReportTerms',
            userRecord: 'auth/getUserRecord',                    
        }),
    },
    methods: {
        ...mapActions({
            getAcademicTerms: 'report/getAcademicTerms',
        }),
        
        ...mapMutations({
            setOverlay: 'auth/setOverlay',
        }),

        displayReport(item){           
            this.reportCard = true;
            this.url = `${process.env.VUE_APP_API_URI}/api/report-card/${item.term}/${item.form_class_id}/${this.studentId}`;
            this.reportName = `Report Card - ${item.subtitle}`; 
        },
        async initialize(){
            this.setOverlay(true);
            try {
                const { data } = await this.getAcademicTerms({ id: this.studentId });
                // console.log(response);
                //console.log(this.reportTerms);
                data.forEach(term => {
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id
                    })
                });
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.setOverlay(false);
            
        },
        closeReport(){
            console.log('report closing ...');
            this.src = '';
            this.selected = -1;
        }
    }
   
    
}
</script>